var React = require('react');

function Ss (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#078930","d":"M0 336h640v144H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 144h640v192H0z","key":1}),React.createElement("path",{"d":"M0 0h640v144H0z","key":2}),React.createElement("path",{"fill":"#da121a","d":"M0 168h640v144H0z","key":3}),React.createElement("path",{"fill":"#0f47af","d":"M0 0l415.7 240L0 480z","key":4}),React.createElement("path",{"fill":"#fcdd09","d":"M200.7 194.8L61.7 240l139 45.1L114.9 167v146z","key":5})]);
}

Ss.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ss;

Ss.default = Ss;
